<template>
  <div class="home">
    <el-carousel
      trigger="click"
      class="carousel wow animate__animated animate__fadeInRight"
      :height="carouselHeight"
      :autoplay="true"
      arrow="always"
      
    >
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div class="width100">
          <!--<video
            v-if="item.videoUrl"
            width="100%"
            height="100%"
            :src="item.videoUrl"
            style="object-fit: cover"
            autoplay
            loop
            muted
          ></video>-->
          <img
            :src="item.imgUrl"
            width="100%"
            height="100%"
            style="object-fit: cover"
            alt=""
          />
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- s2 简介 -->
    <section class="s2-box">
      <div class="container">
        <el-row class="box1">
          <el-col :sm="24" :md="12" class="box1-1">
            <img src="../assets/img/img1.png" alt="" class="img" />
          </el-col>
          <el-col :md="11" class="box1-2 wow animate__animated animate__fadeInUp">
            <p class="t-indent-2">
              滨海古园于1985年获批创建，1986年正式开园。多年来，滨海古园始终坚持党建引领，固本强基，高质量发展，逐步实现了环境园林化、葬式多样化、墓型艺术化和办公智能化。
            </p>
            <p class="t-indent-2">
              每年古园服务的海内外客户多达80余万。作为民政单位基层服务窗口，古园坚守殡葬阵地，守护民生所需；勇做殡葬改革“先行者”和“排头兵”，创新殡葬理念，谱写服务新篇，在长期的理论积淀和实践积累中将自身打造成为海派城市殡葬文化的一张靓丽名片……
            </p>
          </el-col>
        </el-row>
        <el-row class="box3 wow animate__animated animate__fadeInUp">
          <el-col :span="12" :md="{ offset: 12 }">
            <custom-button class="box3 btnicon2" size="default" @click="toPage('/about')"
                    >查看详情
                    <img
                      src="../assets/img/icon2.png"
                      height="28"
                      class="ma-l-10"
                    />
                  </custom-button>

          </el-col>
        </el-row>
        <el-row class="box4 wow animate__animated animate__fadeInUp">
          <el-col :md="{ offset: 6, span: 16 }">
            <el-row>
              <el-col :span="6" class="flex f-jcenter hover-top" v-for="(item, index) in categorylist" :key="index">
                <div  class="flex f-jcenter hover-top c-pointer" @click="toPage('/about?id='+item.Id)">
                  <img :src="item.Image" class="img2" />
                  <div>
                    <div class="t1">{{item.Name}}</div>
                    <div class="t2">{{item.EName}}</div>
                  </div>
                </div>
              </el-col>
              <!--<el-col :span="6" class="flex f-jcenter hover-top">
                <img src="../assets/img/home_icon/i2.png" class="img2" />
                <div>
                  <div class="t1">古园风光</div>
                  <div class="t2">Scenery</div>
                </div>
              </el-col>
              <el-col :span="6" class="flex f-jcenter hover-top">
                <img src="../assets/img/home_icon/i3.png" class="img2" />
                <div>
                  <div class="t1">古园文化</div>
                  <div class="t2">culture</div>
                </div>
              </el-col>
              <el-col :span="6" class="flex f-jcenter hover-top">
                <img src="../assets/img/home_icon/i4.png" class="img2" />
                <div>
                  <div class="t1">古园品牌</div>
                  <div class="t2">brand</div>
                </div>
              </el-col>-->
            </el-row>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 墓园园区 -->
    <section class="s3-box">
      <div class="container">
        <el-row>
          <el-col :sm="24" :md="24" class="box1-1">
            <div class="title-box wow animate__animated animate__fadeInLeft">
              <div class="h-title">ECOLOGICAL  BURIAL</div>
              <div class="title2">生态节地葬</div>
            </div>
          </el-col>
        </el-row>

        <!--<el-row>
          <el-col :sm="24" :md="24" class="box1-1">
            <div class="tab-box wow animate__animated animate__fadeInRight">
              <div :class="cemeteryCategoryId== item.Id?'active hover-top':'hover-top'" v-for="(item, index) in cemeteryCategory" :key="index" @click="loadData2(item.Id)">{{item.Name}}</div>
            </div>
          </el-col>
        </el-row>-->

        <el-row :gutter="30" class="list ma-t-40">
          <el-col :sm="8" v-for="(item, index) in cemeterylist" :key="index">
            <div class="list-box wow animate__animated animate__fadeInRight" @click="toPage('/cemetery/detail?id=' + item.Id+'&categoryId='+item.CategoryId)">
              <img
                class="list-img"
                :src="item.Image"
              />
              <div class="titles">{{item.Title}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 客户服务 -->
    <section class="s4-box">
      <div class="container">
        <el-row>
          <el-col :sm="24" :md="24">
            <div class="title-box wow animate__animated animate__fadeInLeft">
              <div class="h-title">customer service</div>
              <div class="title2">客户服务</div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24">
            <div class="boxs" v-if="serviceIndex != -1&&serviceList.length>0">
              <el-row :sm="24" :md="24" class="tab-box">
                <el-col
                  v-for="(item, index) in serviceList"
                  :key="index"
                  :class="{
                    active: index == serviceIndex,
                  }"
                >
                  <div
                    class="width100 height100 flex f-center f-jcenter flex-direction"
                    @mouseover="changeEnter('serviceIndex', index)"
                  >
                    <div>{{ item.Title }}</div>
                    <img
                      class="img-icon"
                      v-if="index == serviceIndex"
                      src="@/assets/img/icon1.png"
                    />
                  </div>
                </el-col>
              </el-row>
              <div class="content" v-if="serviceIndex != -1&&serviceList.length>0">
                <img class="imgs" :src="serviceList[serviceIndex].Image" />
                <div class="name-box">
                  <div class="titles">
                    <img src="../assets/img/icon3.png" height="40" />
                    <span>{{ serviceList[serviceIndex].Title }}</span>
                  </div>
                  <div
                    class="contents"
                    v-html="serviceList[serviceIndex].Detail"
                  ></div>
                  <custom-button class="box3" size="default" @click="toPage('/customer/detail?id=' + serviceList[serviceIndex].Id+'&title=客户服务')"
                    >查看详情
                    <img
                      src="../assets/img/icon2.png"
                      height="28"
                      class="ma-l-10"
                    />
                  </custom-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 人文纪念 -->
    <section class="s5-box">
      <div class="container">
        <el-row>
          <el-col :sm="24" :md="24">
            <div class="title-box wow animate__animated animate__fadeInLeft">
              <div class="h-title">commemorate</div>
              <div class="title2">人文纪念</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="celebrityList.length>0">
        <div class="content" :style="{ backgroundImage: 'url(' + celebrityList[commemorateIndex].Image + ')', }" >
        <div class="sybox_4nrtext" v-for="(item, index) in celebrityList" :key="index" :class="{ active: commemorateIndex == index, }" >
          <!--<img class="img" :src="item.Image" alt="" />-->
          <div class="txt">{{ item.Detail }}</div>
        </div>
        <div :gutter="30" class="list">
          <div class="container">
            <el-col :sm="6" :xs="12" v-for="(item, index) in celebrityList" :key="index" >
              <div class="list-box" :class="{ active: commemorateIndex == index, }"
                @mouseover="changeEnter('commemorateIndex', index)"  @click="toPage('/commemorate/list?id='+item.Id)"
              >
                <img class="list-img" :src="item.Icon" v-if="commemorateIndex != index" />
                <div class="desc t-center">
                  <div class="titles">{{ item.Name }}</div>
                  <div class="titles-en">{{ item.EnName }}</div>
                  <img
                    class="img-desc"
                    v-if="index == commemorateIndex"
                    src="@/assets/img/icon7.png"
                  />
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </div>
      </div>
    </section>

    <!-- 古园动态 -->
    <section class="s4-box s6-box">
      <div class="container">
        <el-row>
          <el-col :sm="24" :md="24">
            <div class="title-box wow animate__animated animate__fadeInLeft">
              <div class="h-title">News updates</div>
              <div class="title2">古园动态</div>
              <div class="more c-pointer" @click="toPage('/news')">
                <div>MORE</div>
                <div>查看更多+</div>
              </div>
            </div>
          </el-col>
        </el-row>

        <div class="news-box" v-if="newsList.length>2">
          <div class="big c-pointer" @click="btnClick(newsList[0])">
            <img class="img" :src="newsList[0].Image" />
            <div class="news-title">
              <div class="news-name t-omit-1">{{ newsList[0].Title }}</div>
              <!--<div class="news-time">
                {{ newsList[0].month }}/<span>{{ newsList[0].day }}</span>
              </div>-->
            </div>
          </div>
          <div class="small">
            <div
              class="news-list"
              v-for="(item, index) in newsList.slice(1, 3)"
              :key="index"
                @click="btnClick(item)"
            >
              <img class="img" :src="item.Image" />
              <div class="news-title">
                <div class="news-name t-omit-1">{{ item.Title }}</div>
                <!--<div class="news-time">
                  {{ item.month }}/<span>{{ item.day }}</span>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        carouselHeight: "980px",
        bannerList: [
          //{
          //  videoUrl: "https://guyuan-oss.oss-cn-shanghai.aliyuncs.com/Website/Banner/37659d35a833402986c657c25bfad7a1_o_1i2b67852bu4huf5jb1ugb1bgac.mp4",
          //},
          {
            imgUrl: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/9040e6b38c434df9b6c334f8b543e864_大门.png",
          },
          {
            imgUrl: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/3b394cbbb004429e8042691f0b08ba1b_全景-1.png",
          },
          //{
          //  imgUrl: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/90dd7dfd17ec40468b730040561aaf93_全景-2.png",
          //},
        ],
        serviceList: this.$store.state.customerCateList,
        serviceIndex: -1,
        commemorateList: [
          {
            img: "http://www.gulinyuan.com/Upload/20230214/20230214113403961202.png",
            txt: "名人之林这片辽阔秀丽的土地上，安置着诸多生前曾在沪上工作或者生活的社会各界名人的墓碑、衣冠冢、雕像。如滑稽泰斗姚慕双、数学家谷超豪与胡和生夫妇、国际遗传学家谈家桢、表演艺术家赵丹……先贤作古，为了更好地铭记缅怀他们，设计师将满腔敬意融入墓碑和塑像设计，以求真切还原墓主人生前的卓越风采。",
            name: "名人之林",
            nameEn: "celebrity",
            icon: require("@/assets/img/home_icon/i5.png"),
            bg: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/f26499af3fc144788d9653e59d6ff518_2.jpg",
          },
          {
            img: "http://www.gulinyuan.com/Upload/20230214/20230214113403961202.png",
            txt: "爱心苑于2007年4月落成，主要是一处安葬已故孤寡老人骨灰的公益性墓区，苑区内还建有“无主骨灰纪念碑”。苑区名“爱心苑”三个字，由中国红十字会前主席陈铁迪亲笔题写。",
            name: "爱心苑",
            nameEn: "Life culture",
            icon: require("@/assets/img/home_icon/i6.png"),
            bg: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/648dac05e84f4d0b88fdbc3371812552_3.jpg",
          },
          {
            img: "http://www.gulinyuan.com/Upload/20230214/20230214113403961202.png",
            txt: "滨海古园从2002年起，有计划、分步骤地推进海葬纪念硬件建设，修建了上海市唯一一处集中纪念海葬逝者的场所——海葬纪念苑，每年3月举办海葬公祭典礼，缅怀海葬先行者，鼓励更多的市民了解海葬，参与谱写上海海葬事业新篇章。",
            name: "海葬纪念馆",
            nameEn: "Sea burial",
            icon: require("@/assets/img/home_icon/i7.png"),
            bg: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/74de049a1d0043a1be5489325364e2ca_4.jpg",
          },
          {
            img: "http://www.gulinyuan.com/Upload/20230214/20230214113403961202.png",
            txt: "英烈苑是集中安葬烈士和英模的墓区。“英烈苑”纪念墙上的“浩气长存”四个大字，是沪上著名书法家周慧珺亲笔题写。目前在“英烈苑”中，已经安葬了20多名烈士与英模的骸骨或骨灰。",
            name: "英烈苑",
            nameEn: "Yinglie Garden",
            icon: require("@/assets/img/home_icon/i8.png"),
            bg: "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/About/About/Content/345bb742989040cfa2c57ab65e8c5b49_1.jpg",
          },
        ],
        commemorateIndex: 0,
        newsList: [ ],
        //墓园园区
        cemeterylist:[],
        cemeteryCategory:[],
        cemeteryCategoryId:"",
        categorylist:[],
        celebrityList:[],
      };
    },
    created() {
      //this.checkWidth();
    },
    mounted() {
      this.$nextTick(() => {
        this.$wow.init();
        this.serviceIndex = 0;
        this.loadnewsList();
        this.CemeteryCategory();
        this.loadcategoryData();
        this.carouselHeight=(document.body.clientWidth/1280*720)+"px";
        this.loadCelebrityList();
        //需要写在mounted，否则可能读取空内容
        this.serviceList=this.$store.state.customerCateList;
      });
    },
    methods: {
      btnClick(item) {
        if(item.Href!=null&&item.Href!=""){
          window.location.href=item.Href;
        }else{
          this.$router.push({
            path: "/news/detail?id="+item.Id,
          })
        }
      },
      loadCelebrityList() {
        this.$request({
            url: "/v1/Celebrity/Category/Query",
            method: "GET",
          })
          .then((res) => {
            this.celebrityList = res;
          });
      },
      loadnewsList() {
        this.$request({
            url: "/v1/News/News/QueryPage",
            method: "GET",
          })
          .then((res) => {
            this.newsList = res.List;
          });
      },
      //墓园园区分类
      CemeteryCategory() {
        this.$request({
            url: "/v1/Cemetery/Category/Query",
            method: "GET",
          })
          .then((res) => {
            this.cemeteryCategory = res;
            setTimeout(() => {
              this.loadData2(this.cemeteryCategory[0].Id);
            }, 100);
          });
      },
      //墓园园区列表
      loadData2(categoryId) {
        this.cemeteryCategoryId=categoryId;
        this.$request({
            url: "/v1/Cemetery/Cemetery/QueryPage",
            method: "GET",
            params:{
              categoryId:categoryId,
            }
          })
          .then((res) => {
            this.cemeterylist = res.List;
          });
      },
      //联系我们分类
      loadcategoryData() {
        this.$request({
            url: "/v1/About/Category/Query",
            method: "GET",
          })
          .then((res) => {
            this.categorylist = res;
          });
      },
      checkWidth: function () {
        if (window.innerWidth < 992) {
          this.carouselHeight = "260px";
        }
      },

      changeEnter(type, index) {
        this[type] = index;
      },

      toPage(url) {
        this.$router.push({
          path: url,
        })
      }
    },
    computed: {},
    watch: {
      '$store.state.customerCateList': {
        immediate: true,
        handler(newVal, oldVal) {
          console.log("customerCateList1",newVal)
          if (newVal) {
            console.log("customerCateList",newVal)
            this.serviceList=newVal;
          }
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  :global(.el-carousel__button) {
    /* 新的样式 */
    background-color: #257857;
  }
  .el-col-md-offset-6{
    margin-left:40%;
  }
  .s2-box {
    height: 860px;
    width: 100%;
    background: url("../assets/img/bg3.png") no-repeat;
    background-size: cover;
    .box1 {
      padding-top: 150px;
      .box1-1 {
        .img {
          width: 500px;
        }
      }
      .box1-2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 10;
        overflow: hidden;
        word-break: break-all;
        line-height: 2em;
      }
    }
    .btnicon2{
      width: 318px;
      height: 68.4px;
    }
    .box3 {
      margin-top: 40px;
    }

    .box4 {
      margin-top: 180px;
      .img2 {
        margin-right: 10px;
        width: 60px;
        height: 60px;
      }
      .t1 {
        font-weight: bold;
        font-size: 20px;
        margin-top: 5px;
      }
      .t2 {
        font-size: 28px;
        //字母大写
        text-transform: uppercase;
      }
    }
  }

  .s3-box {
    width: 100%;
    background: url("../assets/img/bg6.png") no-repeat;
    background-size: cover;

    .tab-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 25px 0;
      div {
        width: 238px;
        height: 57px;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          background: url("../assets/img/btnbg1.png") no-repeat;
          background-size: cover;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      .list-box {
        background-color:#fff;
        box-shadow: 0px 5px 5px #888888;
        &:hover {
          transform: scale(1.05);
          .titles {
            background-image: url("@/assets/img/title-cloud2.png");
            background-size: cover;
            color: #fff;
          }
        }
        .list-img {
          width: 100%;
          height: 269px;
          vertical-align: middle;
          -webkit-transition: all 0.5s;
          -moz-transition: all 0.5s;
          -ms-transition: all 0.5s;
          -o-transition: all 0.5s;
          transition: all 0.5s;
          object-fit: cover;
        }
        .titles {
          //background: url("../assets/img/title-cloud.png") no-repeat;
          //background-size: cover;
          width: 100%;
          height: 60px;
          font-size: 20px;
          color: #000000;
          margin-bottom: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .s4-box {
    width: 100%;
    background: url("../assets/img/bg7.png") no-repeat;
    background-size: cover;
    .boxs {
      padding: 65px 0;
      .tab-box {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #0a6443;
        > div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 95px;
          background: #efeeee;
          border-right: 1px solid #0a6443;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 24px;
          color: #000000;
          transition: all 0.8s;
          &:last-child {
            border-right: none;
          }
          &.active,
          &:hover {
            background-image: url("../assets/img/service.png");
            background-position: center;
            background-size: 100%;
            background-color: #0a6443;
            background-repeat: no-repeat;
            color: #fff;
            cursor: pointer;
            transition: all 0.8s;
          }
        }
        .img-icon {
          margin-top: 10px;
        }
      }
      .content {
        width: 100%;
        position: relative;
        height: 594px;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        -ms-transition: all 0.5s;
        -o-transition: all 0.5s;
        transition: all 0.5s;
        .imgs {
          width: 100%;
          height: 100%;
          object-fit: cover;
          -webkit-transition: all 0.5s;
          -moz-transition: all 0.5s;
          -ms-transition: all 0.5s;
          -o-transition: all 0.5s;
          transition: all 0.5s;
        }
        .name-box {
          padding: 0 37px 0 37px;
          position: absolute;
          left: 0;
          top: 0;
          width: 40%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.4);
          .titles {
            padding-top: 85px;
            display: flex;
            align-items: center;
            span {
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 36px;
              color: #ffffff;
            }
            img{
              transform: rotate(180deg);
              margin-right:10px;
            }
          }
          .contents {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 20px;
            color: #ffffff;
            line-height: 50px;
            margin-top: 30px;
          }
          .box3 {
            width: 255px;
            height: 55.8px;
            margin-top: 30px;
          }
        }
      }
    }
  }

  .s5-box {
    .content {
      margin-top: 55px;
      width: 100%;
      background-size: cover;
      position: relative;
      z-index: 1;
      padding: 564px 0 80px;
      background-repeat: no-repeat;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
      }
      .sybox_4nrtext {
        padding: 0;
        height: 0;
        overflow: hidden;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        -ms-transition: all 0.5s;
        -o-transition: all 0.5s;
        transition: all 0.5s;
        &.active {
          padding: 10% 0;
          height: auto;
          opacity: 1;
        }
        .img {
          display: block;
          margin: 0 auto;
        }
        .txt {
          font-size: 20px;
          line-height: 40px;
          overflow: hidden;
          width: 60%;
          text-align: center;
          color: #fff;
          margin: 0 auto;
          margin-top: 2%;
        }
      }
      .list {
        background: rgba($color: #fff, $alpha: 0.6);
        width: 100%;
        overflow: hidden;
        .el-col {
          &:last-child {
            .list-box {
              &::after {
                background: none;
              }
            }
          }
        }
        .list-box {
          height: 170px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          position: relative;
          -webkit-transition: all 0.5s;
          -moz-transition: all 0.5s;
          -ms-transition: all 0.5s;
          -o-transition: all 0.5s;
          transition: all 0.5s;
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 80%;
            background: #ffffff;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(0, -50%);
          }
          &.active {
            background-image: url("../assets/img/service.png");
            background-position: center;
            background-size: 100%;
            background-color: #0a6443;
            background-repeat: no-repeat;
            &::after {
              background: none;
            }
            .list-img {
              opacity: 0;
            }
            .desc {
              color: #fff;
              margin-right: 50px;
            }
          }
          .list-img {
            width: 50px;
            height: 50px;
            margin-bottom: 15px;
          }
          .desc {
            font-family: Microsoft YaHei;
            color: #0a6443;
            .titles {
              font-weight: bold;
              font-size: 24px;
            }
            .titles-en {
              font-weight: 400;
              font-size: 18px;
              text-transform: uppercase;
              margin-top: 10px;
            }
            .img-desc {
              position: absolute;
              right: 45px;
              top: 50%;
              width: 55px;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }

  .s6-box {
    .news-box {
      padding: 65px 0;
      display: flex;
      justify-content: space-between;
      .big {
        width: 58%;
        position: relative;
        height: 600px;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .small {
        width: 40%;
        height: 600px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .news-list {
          position: relative;
          height: 290px;
          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .news-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        width: 100%;
        background: rgba($color: #000000, $alpha: 0.6);
        bottom: 0;
        height: 70px;
        .news-name {
          padding-left: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 24px;
          color: #ffffff;
        }
        .news-time {
          font-family: Microsoft YaHei;
          font-weight: 300;
          font-size: 24px;
          color: #ffffff;
          padding-right: 20px;
          span {
            font-size: 30px;
          }
        }
      }
    }
  }

  .title-box {
    position: relative;
    height: 78px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding-top: 70px;
    .h-title {
      height: 78px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 98px;
      line-height: 78px;
      color: #0a6443;
      opacity: 0.08;
      text-transform: uppercase;
    }
    .title2 {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 48px;
      color: #23262e;
      position: absolute;
      bottom: 0;
      left: 0;
      line-height: 48px;
    }
    .more {
      position: absolute;
      bottom: 0;
      right: 0;
      &::after {
        content: "";
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        height: 80%;
        width: 1px;
        background: #6a6a69;
      }
      div {
        color: #0a6443;
        font-family: Microsoft YaHei;
        font-weight: 300;
        &:first-child {
          font-size: 24px;

          text-transform: uppercase;
        }
        &:last-child {
          font-size: 16px;
        }
      }
    }
  }

  // 手机端
  @media only screen and (max-width: 992px) {
    .el-col-md-offset-6{
      margin-left:0%;
    }
    .el-col-6{
      width: 50%;
      margin-bottom: 20px;
    }
    .s2-box {
      height: auto;
      background: url("../assets/img/bg3s.png") no-repeat;
      background-size: cover;
        
      .btnicon2{
        width: 190px;
        height: 41.04px;
      }
      .box1 {
        padding-top: 20px;
        .box1-1 {
          .img {
            width: 200px;
          }
        }
        .box1-2 {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 10;
          overflow: hidden;
          word-break: break-all;
          line-height: 2em;
          font-size:14px;
        }
      }

      .box3 {
        margin-top: 20px;
      }

      .box4 {
        margin-top: 20px;
        .img2 {
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }
        .t1 {
          font-weight: bold;
          font-size: 16px;
        }
        .t2 {
          font-size: 16px;
          //字母大写
          text-transform: uppercase;
        }
      }
    }

    .s3-box {
      .tab-box {
        margin: 20px 0;
        width: 100%;
        justify-content: space-between div {
          width: 40%;
        }
        div.active {
          background-size: 100% 100%;
          height: 50px;
        }
      }

      .list {
        .list-box {
          .list-img {
            height: 175px;
          }
          .titles {
            height: 42px;
            font-size: 18px;
            margin-bottom: 20px;
          }
        }
      }
    }

    .s4-box {
      .boxs {
        padding: 20px 0 0;
        .tab-box {
          > div {
            height: 40px;
            font-size: 14px;
          }

          .img-icon {
            margin-top: 2px;
            width: 15px;
          }
        }
        .content {
          width: 100%;
          position: relative;
          height: 345px;
          .imgs {
            // display: none;
          }
          .name-box {
            padding: 20px;
            width: 100%;
            height: 100%;
            // position: static;
            box-sizing: border-box;
            .titles {
              padding-top: 0;
              img {
                width: 26px;
                height: 26px;
                transform: rotate(180deg);
              }
              span {
                font-size: 26px;
              }
            }
            .contents {
              margin-top: 10px;
              font-size: 18px;
              line-height: 32px;
              font-size:14px;
            }
            .box3 {
              width: 190px;
              height: 41.04px;
              margin-top: 20px;
            }
          }
        }
      }
    }

    .s5-box {
      .content {
        margin-top: 0;
        padding: 260px 0 40px;
        .sybox_4nrtext {
          &.active {
            padding: 20px 0;
          }
          .img {
            width: 40px;
          }
          .txt {
            font-size: 14px;
            line-height: 28px;
            width: 90%;
          }
        }
        .list {
          bottom: 20px;
          .list-box {
            height: 80px;
            margin-bottom: 20px;
            &::after {
              background: none;
            }
            .list-img {
              width: 35px;
              height: 35px;
              margin-bottom: 5px;
            }
            .desc {
              .titles {
                font-size: 16px;
              }
              .titles-en {
                font-size: 14px;
              }
              .img-desc {
                right: 5px;
                top: 50%;
                width: 30px;
              }
            }
            &.active {
              .desc {
                margin-right: 20px;
              }
            }
          }
        }
      }
    }

    .s6-box {
      .news-box {
        padding: 20px 0 0;
        flex-direction: column;
        .big {
          width: 100%;
          height: 205px;
          margin-bottom: 20px;
        }
        .news-title {
          height: 35px;
          .news-name {
            padding-left: 10px;
            font-size: 15px;
          }
          .news-time {
            font-size: 14px;
            padding-right: 10px;
            span {
              font-size: 18px;
            }
          }
        }
        .small {
          width: 100%;
          height: auto;
          .news-list {
            margin-bottom: 20px;
            height: 205px;
          }
        }
      }
    }

    .title-box {
      padding-top: 0;
      height: 38px;
      .h-title {
        font-size: 32px;
        height: 38px;
        line-height: 38px;
      }
      .title2 {
        font-size: 22px;
        line-height: 30px;
      }
      .more {
        div {
          &:first-child {
            font-size: 12px;
          }
          &:last-child {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
